export const LoanFinancer_REQ_LIST_REQUEST = "LoanFinancer_REQ_LIST_REQUEST";
export const LoanFinancer_REQ_LIST_SUCCESS = "LoanFinancer_REQ_LIST_SUCCESS";
export const LoanFinancer_REQ_LIST_FAIL = "LoanFinancer_REQ_LIST_FAIL";

export const GetDialysisService_REQ_LIST_REQUEST = "GetDialysisService_REQ_LIST_REQUEST";
export const GetDialysisService_REQ_LIST_SUCCESS = "GetDialysisService_REQ_LIST_SUCCESS";
export const GetDialysisService_REQ_LIST_FAIL = "GetDialysisService_REQ_LIST_FAIL";

export const DCBEDCAT_LIST_REQUEST = 'DCBEDCAT_LIST_REQUEST';
export const DCBEDCAT_LIST_SUCCESS = 'DCBEDCAT_LIST_SUCCESS';
export const DCBEDCAT_LIST_FAIL = 'DCBEDCAT_LIST_FAIL';

export const DLAllPatientDetails_LIST_REQUEST = 'DLAllPatientDetails_LIST_REQUEST';
export const DLAllPatientDetails_LIST_SUCCESS = 'DLAllPatientDetails_LIST_SUCCESS';
export const DLAllPatientDetails_LIST_FAIL = 'DLAllPatientDetails_LIST_FAIL';

export const DCBedOCCUP_LIST_REQUEST = 'DCBedOCCUP_LIST_REQUEST';
export const DCBedOCCUP_LIST_SUCCESS = 'DCBedOCCUP_LIST_SUCCESS';
export const DCBedOCCUP_LIST_FAIL = 'DCBedOCCUP_LIST_FAIL';